module.exports = __webpack_public_path__ + "static/media/messa3.91bd2bf7.jpg";